<app-page-container [DataTableSchema]="dataTableSchema" [title]="data" [dynamicFormArray]="filterSchema"
  [props]="props"></app-page-container>

<ng-template #tenureInfoTemplate let-data>
  <section class="tenure-info-container">
      <header class="tenure-info-header">
        <span>Tenure Info</span>
        <button mat-button class="tenure-close-btn"><i
            class="fa-solid fa-xmark"></i></button>
      </header>
    <span class="tenure-info-content">
      Associate Initial Brand Start Date has been changed from ({{data['prevTenure']}}) to ({{data['currentTenure']}})
    </span>
  </section>
</ng-template>